<template>
    <!-- 混合资源的列表 -->
    <div>
        <!-- 遍历 -->
        <template v-for="item in list" :key="item.id">
            <div class="box" >
                <div class="cover-wrap">
                    <van-image  @click="go2detail(item)"
                                :src="item.cover"
                                fit="cover" width="32vw" height="20vw"/>
                </div>
                <div class="info-wrap">
                    <!-- 点击前往名人详情 -->
                    <div class="title" @click="go2detail(item)">
                        {{item.title}}
                    </div>
                    <introduction :intr="item.description || item.title" :limit="30"/>
                </div>
            </div>
            <div class="divider"></div>
        </template>
    </div>
</template>

<script>
import Introduction from "@/components/introduction";

export default {
    name: "index",
    props:['list'],
    components:{Introduction},
    methods:{
        go2detail(item){
            let url;
            switch (item.type){
                case 'HTML':case 'HTML_COLLECT':
                    url = `/r/article/${item.id}`;break;
                case 'IMG': url = `/r/img/${item.id}`;break;
                case 'PDF': url = `/r/book/${item.id}`;break;
                case 'VIDEO':url = `/r/video/${item.id}`;break;
                case 'AUDIO':case 'MUSIC':
                    url = `/r/music/${item.id}`;break;
                case 'GU_JU':url = `/r/attraction/1485866792526573569`;break;
                // 外部链接
                case 'LINK':{
                    // 活动
                    if(item.topicPath && item.topicPath.length
                        && item.topicPath[0].code === 'activity'){
                        url = `/activity/detail/${item.id}`
                        break;
                    }
                    // 外部链接直接打开
                    window.location = item.path
                    return;
                }
                // eslint-disable-next-line no-fallthrough
                default:
                    // 名人故居
                    if(item.topicCode === 'guju'){
                        url = `/r/attraction/${item.id}`
                        break;
                    }
                    console.error(`unknown type:${item.type}`,item)
                    return
            }
            // console.log(item.type,url)
            this.$router.push(url)
        }
    }
}
</script>

<style scoped>
.type{

}
.divider {
    width: 100vw;
    height: 5px;
    background: #EFEFEF;
    margin-top: 10px;
}
.box {
    padding: 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
}
.info-wrap{
    width: calc(100% - 10px - 32vw);
    color: #4e4e4e;
}
.title{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
}
</style>
